const bankCategory = [
  {
    path: '/bank-category',
    name: 'bank-category',
    component: () => import('@/views/bank-category/BankCategory.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'BankCategoryAdmin',
    },
  },
]
export default bankCategory
